'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _validate = require('validate.js');

var _validate2 = _interopRequireDefault(_validate);

var _asyncValidator = require('./asyncValidator');

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

var _formatsValidator = require('./formatsValidator');

var _formatsValidator2 = _interopRequireDefault(_formatsValidator);

var _datetimeExtension = require('./datetimeExtension');

var _datetimeExtension2 = _interopRequireDefault(_datetimeExtension);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setup = function setup() {
	_validate2.default.validators.asyncValidator = _asyncValidator2.default;
	_validate2.default.validators.formats = _formatsValidator2.default;
	_validate2.default.extend(_validate2.default.validators.datetime, _datetimeExtension2.default);
};

var _default = setup;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(setup, 'setup', 'src/validators/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/validators/index.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/validators/index.js